export const isVideo = (media) => {
  return (
    media.endsWith(".mp4") || media.endsWith(".mkv") || media.endsWith(".webm")
  );
};

export const isVideov2 = (media) => {
  const videoExtensions = [".mp4", ".mkv", ".webm"];
  const fileExtension = media?.slice(media?.lastIndexOf("."));

  return videoExtensions.includes(fileExtension);
};
